import { useEffect } from 'react';
import { gspx } from '@rsos/gainsight';
import useAppNameToPage from './useAppNametoPage';

const trackBeforeUnload = app => {
  gspx.trackCustomEvent('Auth', {
    Category: 'Auth',
    'Launched date': new Date(),
    name: `user left ${app} page`,
  });
};

const useBeforeUnload = () => {
  const readableName = useAppNameToPage();

  useEffect(() => {
    try {
      window.onbeforeunload = () => {
        if (readableName) {
          trackBeforeUnload(readableName);
        }
      };
    } catch {
      //silently fail
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useBeforeUnload;
